<template lang="pug">
div
  ul#promotioncontainertab.nav.nav-tabs(role='tablist')
    li.nav-item(v-if="showActionButton('promotion')" @click="refresh('promotion')")
      a#promotion-tab.nav-link(:class="{ 'active': currTab == 'promotion' }" data-toggle='tab' href='#promotion-content' role='tab' aria-controls='promotion' aria-selected='false') {{ $t("ui.promotion") }}
    li.nav-item(v-if="showActionButton('promomember')" @click="refresh('promomember')")
      a#promomember-tab.nav-link(:class="{ 'active': currTab == 'promomember' }" data-toggle='tab' href='#promomember-content' role='tab' aria-controls='promomember' aria-selected='false') {{ $t("ui.promotion_member") }}
    li.nav-item(v-if="showActionButton('promosignup')" @click="refresh('promosignup')")
      a#promosignup-tab.nav-link(:class="{ 'active': currTab == 'promosignup' }" data-toggle='tab' href='#promosignup-content' role='tab' aria-controls='promosignup' aria-selected='false') {{ $t("ui.promotion_signup") }}
    li.nav-item(v-if="showActionButton('promotionvoucher')" @click="refresh('promotionvoucher')")
      a#promotionvoucher-tab.nav-link(:class="{ 'active': currTab == 'promotionvoucher' }" data-toggle='tab' href='#promotionvoucher-content' role='tab' aria-controls='promotionvoucher' aria-selected='false') {{ $t("ui.promotion_voucher") }}
    li.nav-item(v-if="showActionButton('promofree')" @click="refresh('freecredit')")
      a#freecredit-tab.nav-link(:class="{ 'active': currTab == 'freecredit' }" data-toggle='tab' href='#freecredit-content' role='tab' aria-controls='freecredit' aria-selected='false') {{ $t("ui.free_credit") }}
    li.nav-item(v-if="showActionButton('promomemberfree')" @click="refresh('freecreditmember')")
      a#freecreditmember-tab.nav-link(:class="{ 'active': currTab == 'freecreditmember' }" data-toggle='tab' href='#freecreditmember-content' role='tab' aria-controls='freecreditmember' aria-selected='false') {{ $t("ui.free_credit_member") }}
    li.nav-item(v-if="showActionButton('promotion')" @click="refresh('sendmessage')")
      a#sendmessage-tab.nav-link(:class="{ 'active': currTab == 'sendmessage' }" data-toggle='tab' href='#sendmessage-content' role='tab' aria-controls='sendmessage' aria-selected='false') {{ $t("ui.message") }}
    li.nav-item(v-if="showActionButton('trigger')" @click="refresh('trigger')")
      a#trigger-tab.nav-link(:class="{ 'active': currTab == 'trigger' }" data-toggle='tab' href='#trigger-content' role='tab' aria-controls='trigger' aria-selected='false') {{ $t("ui.trigger") }}
    li.nav-item(v-if="showActionButton('issuefreespin')" @click="refresh('bulkissuefreespin')")
      a#bulkissuefreespin-tab.nav-link(:class="{ 'active': currTab == 'bulkissuefreespin' }" data-toggle='tab' href='#bulkissuefreespin-content' role='tab' aria-controls='bulkissuefreespin' aria-selected='false') {{ $t("ui.free_spin_bulk_issue") }}


  #promotioncontainertabcontent.tab-content.tab-bordered
    #promotion-content.tab-pane.fade(:class="{ 'active show': currTab == 'promotion' }" v-if="showActionButton('promotion') && currTab == 'promotion'" role='tabpanel' aria-labelledby='promotion-tab')
      promotionTab(ref="promotionTab")
    #promomember-content.tab-pane.fade(:class="{ 'active show': currTab == 'promomember' }" v-if="showActionButton('promomember') && currTab == 'promomember'" role='tabpanel' aria-labelledby='promomember-tab')
      promoMemberTab(ref="promoMemberTab")
    #promosignup-content.tab-pane.fade(:class="{ 'active show': currTab == 'promosignup' }" v-if="showActionButton('promosignup') && currTab == 'promosignup'" role='tabpanel' aria-labelledby='promosignup-tab')
      promoSignupTab(ref="promoSignupTab")
    #promotionvoucher-content.tab-pane.fade(:class="{ 'active show': currTab == 'promotionvoucher' }" v-if="showActionButton('promotionvoucher') && currTab == 'promotionvoucher'" role='tabpanel' aria-labelledby='promotionvoucher-tab')
      promotionVoucherTab(ref="promotionVoucherTab")
    #freecredit-content.tab-pane.fade(:class="{ 'active show': currTab == 'freecredit' }" v-if="showActionButton('promofree') && currTab == 'freecredit'" role='tabpanel' aria-labelledby='freecredit-tab')
      freeCreditTab(ref="freeCreditTab")
    #freecreditmember-content.tab-pane.fade(:class="{ 'active show': currTab == 'freecreditmember' }" v-if="showActionButton('promomemberfree') && currTab == 'freecreditmember'" role='tabpanel' aria-labelledby='freecreditmember-tab')
      freeCreditMemberTab(ref="freeCreditMemberTab")
    #sendmessage-content.tab-pane.fade(:class="{ 'active show': currTab == 'sendmessage' }" v-if="showActionButton('promotion') && currTab == 'sendmessage'" role='tabpanel' aria-labelledby='sendmessage-tab')
      sendMessageTab(ref="sendMessageTab")
    #trigger-content.tab-pane.fade(:class="{ 'active show': currTab == 'trigger' }" v-if="showActionButton('trigger') && currTab == 'trigger'" role='tabpanel' aria-labelledby='trigger-tab')
      triggerTab(ref="triggerTab")
    #bulkissuefreespin-content.tab-pane.fade(:class="{ 'active show': currTab == 'bulkissuefreespin' }" v-if="showActionButton('issuefreespin') && currTab == 'bulkissuefreespin'" role='tabpanel' aria-labelledby='bulkissuefreespin-tab')
      bulkIssueFreespinTab(ref="bulkIssueFreespinTab")

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import promotionTab from "@/components/operatorTab/promotionTab.vue";
import promoMemberTab from "@/components/operatorTab/promoMemberTab.vue";
import promoSignupTab from "@/components/operatorTab/promoSignupTab.vue";
import promotionVoucherTab from "@/components/operatorTab/promotionVoucherTab.vue";
import sendMessageTab from "@/components/operatorTab/sendMessageTab.vue";
import triggerTab from "@/components/operatorTab/triggerTab.vue";
import freeCreditTab from "@/components/operatorTab/freeCreditTab.vue";
import freeCreditMemberTab from "@/components/operatorTab/freeCreditMemberTab.vue";
import bulkIssueFreespinTab from "@/components/operatorTab/bulkIssueFreespinTab.vue";
import SubmitButton from "@/library/SubmitButton.vue";

export default {
  components: {
    SubmitButton,
    promotionTab,
    promoMemberTab,
    promoSignupTab,
    promotionVoucherTab,
    sendMessageTab,
    triggerTab,
    freeCreditTab,
    freeCreditMemberTab,
    bulkIssueFreespinTab
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    currTab: 'promotion'
  }),
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
  },
  mounted: function() {
    // this.getBannerList(true);
  },
  methods: {
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    refresh: function(tab) {
      switch(tab) {
        case 'promotion':
          this.tabChecking();
          break
        case 'promomember':
          this.currTab = 'promomember'
          this.$nextTick(() => {
            if(this.$refs.promoMemberTab) {
              this.$refs.promoMemberTab.refresh();
            }
          });
          break
        case 'promosignup':
          this.currTab = 'promosignup'
          this.$nextTick(() => {
            if(this.$refs.promoSignupTab) {
              this.$refs.promoSignupTab.refresh();
            }
          });
          break
        case 'promotionvoucher':
          this.currTab = 'promotionvoucher'
          this.$nextTick(() => {
            if(this.$refs.promotionVoucherTab) {
              this.$refs.promotionVoucherTab.refresh();
            }
          });
          break
        case 'freecredit':
          this.currTab = 'freecredit'
          this.$nextTick(() => {
            if(this.$refs.freeCreditTab) {
              this.$refs.freeCreditTab.refresh();
            }
          });
          break
        case 'freecreditmember':
          this.currTab = 'freecreditmember'
          this.$nextTick(() => {
            if(this.$refs.freeCreditMemberTab) {
              this.$refs.freeCreditMemberTab.refresh();
            }
          });
          break
        case 'sendmessage':
          this.currTab = 'sendmessage'
          this.$nextTick(() => {
            if(this.$refs.sendMessageTab) {
              this.$refs.sendMessageTab.refresh();
            }
          });
          break
        case 'trigger':
          this.currTab = 'trigger'
          this.$nextTick(() => {
            if(this.$refs.triggerTab) {
              this.$refs.triggerTab.refresh();
            }
          });
          break
        case 'bulkissuefreespin':
          this.currTab = 'bulkissuefreespin'
          this.$nextTick(() => {
            if(this.$refs.bulkIssueFreespinTab) {
              this.$refs.bulkIssueFreespinTab.refresh();
            }
          });
          break
      }
    },
    tabChecking() {
      if(this.showActionButton('promotion')) {
        this.currTab = 'promotion'
        this.$nextTick(() => {
          if(this.$refs.promotionTab) {
            this.$refs.promotionTab.refresh();
          }
        });
      } else if(this.showActionButton('promomember')) {
        this.currTab = 'promomember'
        this.$nextTick(() => {
          if(this.$refs.promotionMemberTab) {
            this.$refs.promotionMemberTab.refresh();
          }
        });
      } else if(this.showActionButton('promosignup')) {
        this.currTab = 'promosignup'
        this.$nextTick(() => {
          if(this.$refs.promoSignupTab) {
            this.$refs.promoSignupTab.refresh();
          }
        });
      } else if(this.showActionButton('promotionvoucher')) {
        this.currTab = 'promotionvoucher'
        this.$nextTick(() => {
          if(this.$refs.promotionVoucherTab) {
            this.$refs.promotionVoucherTab.refresh();
          }
        });
      }
      else if(this.showActionButton('promofree')) {
        this.currTab = 'freecredit'
        this.$nextTick(() => {
          if(this.$refs.freeCreditTab) {
            this.$refs.freeCreditTab.refresh();
          }
        });
      } else if(this.showActionButton('promomemberfree')) {
        this.currTab = 'freecreditmember'
        this.$nextTick(() => {
          if(this.$refs.freeCreditMemberTab) {
            this.$refs.freeCreditMemberTab.refresh();
          }
        });
      }
      else if(this.showActionButton('promotion')) {
        this.currTab = 'sendmessage'
        this.$nextTick(() => {
          if(this.$refs.sendMessageTab) {
            this.$refs.sendMessageTab.refresh();
          }
        });
      } else if(this.showActionButton('trigger')) {
        this.currTab = 'trigger'
        this.$nextTick(() => {
          if(this.$refs.triggerTab) {
            this.$refs.triggerTab.refresh();
          }
        });
      } else if(this.showActionButton('issuefreespin')) {
        this.currTab = 'bulkissuefreespin'
        this.$nextTick(() => {
          if(this.$refs.bulkIssueFreespinTab) {
            this.$refs.bulkIssueFreespinTab.refresh();
          }
        });
      }
    }
  }
};
</script>